import React from 'react'
import BasicTextFields from '../../materialUI/FormComponent'

const Forms = () => {
  return (
    <div className="formsection">
      <BasicTextFields />
    </div>
  )
}

export default Forms